// Helper function to parse relevance result from JSON string
export function parseRelevanceResult(jsonString: string): { score: number; verdict: string | null; reasoning: string | null } {
  // Try to extract JSON from the message
  // The message might contain markdown code blocks or other text
  let jsonText = jsonString.trim()
  
  // Remove markdown code blocks if present
  if (jsonText.startsWith('```')) {
    const lines = jsonText.split('\n')
    const startIndex = lines.findIndex(line => line.includes('{'))
    const endIndex = lines.findLastIndex(line => line.includes('}'))
    if (startIndex !== -1 && endIndex !== -1) {
      jsonText = lines.slice(startIndex, endIndex + 1).join('\n')
    }
  }
  
  // Try to find JSON object in the text
  const jsonMatch = jsonText.match(/\{[\s\S]*\}/)
  if (jsonMatch) {
    jsonText = jsonMatch[0]
  }
  
  const result = JSON.parse(jsonText)
  
  // Validate and normalize result
  if (!result || typeof result !== 'object') {
    throw new Error('Invalid result format: not an object')
  }
  
  // Convert score to number if it's a string
  const score = typeof result.score === 'string' ? parseInt(result.score, 10) : 
               typeof result.score === 'number' ? result.score : null
  
  if (score === null || isNaN(score)) {
    throw new Error(`Invalid score value: ${result.score}`)
  }
  
  return {
    score,
    verdict: result.verdict || null,
    reasoning: result.reasoning || null
  }
}
